import { UserDomainEnum } from './user-domain-enum'
import { PaperQuestion } from './paper-question'
import { BizTypeEnum } from './biz-type-enum'

export interface PaperAnswerInterface {
  /**
   * 关联的活动任务 ID
   */
  activityTaskId?: number
  /**
   * 分配试卷id
   */
  paperId: number
  /**
   * 所属提交人
   */
  submitterId?: number
  /**
   * 所属提交人
   */
  submitterDomain: UserDomainEnum
  question?: PaperQuestion
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  questionId: number
  /**
   * 答案内容
   */
  value?: string[]
  /**
   * 是否发布
   */
  isPublished?: boolean
  bizId?: number
  bizType?: BizTypeEnum
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class PaperAnswer implements PaperAnswerInterface {
  /**
   * 关联的活动任务 ID
   */
  activityTaskId?: number
  /**
   * 分配试卷id
   */
  paperId: number
  /**
   * 所属提交人
   */
  submitterId?: number
  /**
   * 所属提交人
   */
  submitterDomain: UserDomainEnum
  question?: PaperQuestion
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  questionId: number
  /**
   * 答案内容
   */
  value?: string[]
  /**
   * 是否发布
   */
  isPublished?: boolean
  bizId?: number
  bizType?: BizTypeEnum
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: PaperAnswerInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      activityTaskId: _activityTaskId,
      paperId: _paperId,
      submitterId: _submitterId,
      submitterDomain: _submitterDomain,
      question: _question,
      id: _id,
      schoolId: _schoolId,
      questionId: _questionId,
      value: _value,
      isPublished: _isPublished,
      bizId: _bizId,
      bizType: _bizType,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.activityTaskId = _activityTaskId
    this.paperId = _paperId
    this.submitterId = _submitterId
    this.submitterDomain = _submitterDomain
    this.question = _question ? new PaperQuestion(_question) : _question
    this.id = _id
    this.schoolId = _schoolId
    this.questionId = _questionId
    this.value = _value
    this.isPublished = _isPublished
    this.bizId = _bizId
    this.bizType = _bizType
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
